module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page09"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ernesto “Che” Guevara, born in Buenos Aires in 1928, was reportedly killed while leading a revolution in Bolivia in 1967. An asthmatic licensed physician, Che joined the Castro brothers and seventy-nine other revolutionaries on the")]), _vm._v(" Granma, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the boat that landed on Cuban shores in 1956, and, as a")]), _vm._v(" comandante, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("played a key role in overthrowing the Batista government on New Year’s Day, 1959.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Che” is an Argentinian colloquialism for “pal.”")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page13"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d30b936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/front.vue
// module id = 69
// module chunks = 0